import { render, staticRenderFns } from "./product-user-review.vue?vue&type=template&id=784f822d&"
import script from "./product-user-review.vue?vue&type=script&lang=js&"
export * from "./product-user-review.vue?vue&type=script&lang=js&"
import style0 from "./product-user-review.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('784f822d')) {
      api.createRecord('784f822d', component.options)
    } else {
      api.reload('784f822d', component.options)
    }
    module.hot.accept("./product-user-review.vue?vue&type=template&id=784f822d&", function () {
      api.rerender('784f822d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/product-user-review.vue"
export default component.exports